import { cleanSuperannuation } from './superannuation';
import { DOCUMENT_NAMES } from '@/core/field-names';

export function cleanDocument(document) {
  switch (document.name) {
    case DOCUMENT_NAMES.SUPERANNUATION: {
      return cleanSuperannuation(document);
    }
    default:
      return document;
  }
}
